import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import {
  LayoutDashboard, Calendar, ClipboardList, BookCheck, BarChart3, Users, Trophy,
  Settings, LogOut, X,
} from 'lucide-react'

const NAV_ITEMS = [
  { key: 'dashboard',   icon: LayoutDashboard, path: '/dashboard'   },
  { key: 'calendar',    icon: Calendar,        path: '/calendar'    },
  { key: 'exams',       icon: ClipboardList,   path: '/exams'       },
  { key: 'homework',    icon: BookCheck,       path: '/homework'    },
  { key: 'results',     icon: BarChart3,       path: '/results'     },
  { key: 'teachers',    icon: Users,           path: '/teachers'    },
  { key: 'rating',      icon: Trophy,          path: '/rating'      },
  { key: 'settings',    icon: Settings,        path: '/settings'    },
]

export default function AuroraSidebar({ isOpen, onClose }) {
  const { t }      = useTranslation()
  const { logout } = useAuth()
  const location   = useLocation()

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          style={{ background: 'rgba(0,0,0,0.35)' }}
          onClick={onClose}
        />
      )}

      <aside
        className={[
          'fixed lg:static inset-y-0 left-0 z-50',
          'flex flex-col',
          'transition-transform duration-300 ease-in-out lg:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full',
        ].join(' ')}
        style={{
          width: 240, flex: '0 0 240px',
          background: 'var(--surface)',
          borderRight: '1px solid var(--border)',
          boxShadow: isOpen ? 'var(--shadow-lg)' : 'none',
        }}
      >
        {/* Logo */}
        <div className="flex items-center justify-between px-5 py-4" style={{ borderBottom: '1px solid var(--border)' }}>
          <Link
            to="/dashboard"
            className="font-bold text-[20px] tracking-tight leading-none"
            style={{ color: 'var(--ink)', textDecoration: 'none' }}
          >
            5mi<span style={{ color: 'var(--coral)' }}>.</span>
            <span style={{ color: 'var(--ink-3)', fontWeight: 400 }}>uz</span>
          </Link>
          <button
            onClick={onClose}
            className="lg:hidden p-1.5 rounded-lg transition-colors"
            style={{ border: 0, background: 'transparent', cursor: 'pointer', color: 'var(--ink-3)' }}
            aria-label="Yopish"
          >
            <X size={18} />
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-3 space-y-0.5 overflow-y-auto">
          {NAV_ITEMS.map((item) => {
            const isActive = location.pathname.startsWith(item.path)
            const Icon = item.icon
            return (
              <Link
                key={item.key}
                to={item.path}
                onClick={onClose}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all"
                style={{
                  color:      isActive ? 'var(--coral)'  : 'var(--ink-2)',
                  background: isActive ? 'var(--coral-soft)' : 'transparent',
                  textDecoration: 'none',
                }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'var(--bg-soft)' }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent' }}
              >
                <Icon size={18} strokeWidth={2} className="flex-shrink-0" />
                <span>{t(`sidebar.${item.key}`, item.key)}</span>
              </Link>
            )
          })}
        </nav>

        {/* Logout */}
        <div className="px-3 pb-4 pt-3" style={{ borderTop: '1px solid var(--border)' }}>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors"
            style={{ border: 0, background: 'transparent', color: 'var(--ink-3)', cursor: 'pointer', font: 'inherit' }}
            onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg-soft)'; e.currentTarget.style.color = 'var(--ink)' }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--ink-3)' }}
          >
            <LogOut size={18} strokeWidth={2} />
            <span>{t('sidebar.logout', 'Chiqish')}</span>
          </button>
        </div>
      </aside>
    </>
  )
}
